/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { compose, mapProps } from 'recompose';
import { withPageViewTracking } from 'components/core/library/tracking-utils';
import { BackToTop } from 'components/core/BackToTop';
import clientPages from './Client';
import ltvPages from './LTV';
import './legalPage.scss';
import { PAGE_TYPES } from '@sparefoot/tracking-events';

const defaultVersion = {
	ltv: '20140805',
	client: '20251016'
};

export const enhance = compose(
	withPageViewTracking(PAGE_TYPES.LEGAL),
	mapProps(({ match }) => ({
		version: match.params.version || defaultVersion[match.params.pageType],
		pageType: match.params.pageType
	}))
);


export function LegalClientLTVPage({ pageType, version }) {
	return (
		<div className="legal-page">
			<div className="section-content">
				{pageType === 'client' && clientPages[version] &&
					React.createElement(clientPages[version])
				}
				{pageType === 'ltv' && ltvPages[version] &&
					React.createElement(ltvPages[version])
				}
			</div>
			<BackToTop />
		</div>
	);
}

LegalClientLTVPage.propTypes = {
	pageType: PropTypes.string,
	version: PropTypes.string
};

export default enhance(LegalClientLTVPage);
